import React from 'react';
import axios from 'axios';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import { constants } from '../../constants/constants';
import UpdatePasswordFormView from '../Views/TO/Reset/UpdatePasswordFormView';


const appVars = AppVars.getInstance();

class UpdatePasswordForm extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            password: "",
            confirmPassword: "",

            passwordFocus: false,
            confirmPasswordFocus: false,
            floatPassword: true,
            floatConfirmPassword: true,
            isPasswordValid: true,
            isConfirmPasswordValid: true,
            
            // State for resending activation email and the outcome of that functionality
            loadingReset: false,

            // Controls the above values based on the outcome of the activate API call, default is false
            passwordLoading: false,
        }
        this.passwordRegex = new RegExp(constants.PASSWORD_VALIDATION_REGEX);
        this.checkPassword = this.checkPassword.bind(this);
        this.checkConfirmPassword = this.checkConfirmPassword.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
        this.reset = this.reset.bind(this);
        this.handleResetSuccess = this.handleResetSuccess.bind(this);
        this.handleResetError = this.handleResetError.bind(this);
        this.onFocusConfirmPassword = this.onFocusConfirmPassword.bind(this);
        this.onBlurConfirmPassword = this.onBlurConfirmPassword.bind(this);
        this.onFocusPassword = this.onFocusPassword.bind(this);
        this.onBlurPassword = this.onBlurPassword.bind(this);
        this.removeFocusPassword = this.removeFocusPassword.bind(this);
        this.removeFocusConfirmPassword = this.removeFocusConfirmPassword.bind(this)
    }

    render() {
        return(
            <UpdatePasswordFormView
            isConfirmPasswordValid = {this.state.isConfirmPasswordValid}
            floatConfirmPassword = {this.state.floatConfirmPassword}
            isPasswordValid = {this.state.isPasswordValid}
            floatPassword = {this.state.floatPassword}
            loadingReset = {this.state.loadingReset}
            passwordLoading = {this.state.passwordLoading}
            passwordFocus = {this.state.passwordFocus}
            confirmPasswordFocus = {this.state.confirmPasswordFocus}
            reset = {this.reset}
            handleConfirmPasswordChange = {this.handleConfirmPasswordChange}
            checkConfirmPassword = {this.checkConfirmPassword}
            onFocusConfirmPassword = {this.onFocusConfirmPassword}
            onBlurConfirmPassword = {this.onBlurConfirmPassword}
            handlePasswordChange = {this.handlePasswordChange}
            onFocusPassword = {this.onFocusPassword}
            onBlurPassword = {this.onBlurPassword}
            checkPassword = {this.checkPassword}
            style = {this.props.style}
            />
        )
    }

    reset(event) {
        // this.checkPassword(event);
        // this.checkConfirmPassword(event);
        event.preventDefault()
        let hasError = false;
        const newPassword = this.state.password.trim();
        const confirmPassword = this.state.confirmPassword.trim();

        // If the new password is invalid there's an error
        if (!newPassword || !this.passwordRegex.test(newPassword)) {
            this.setState({isPasswordValid: false})
            hasError = true;
        }
        // If the confirmation password is invalid or doesn't match the new password there's an error
        if (!confirmPassword || !(confirmPassword === newPassword)) {
            this.setState({isConfirmPasswordValid: false})
            hasError = true;
        }
        if (!hasError) {
            this.setPassword(newPassword);
        }
    }

    async setPassword(password) {
        // Reset Password Call
        this.setState({
            loadingReset: true
        });
        this.setState({
            passwordLoading: true
        });
        await axios({
            headers: {
                'X-BRAND': 'T',
                "x-client" : "FR-Portal-Toyota",
                //'X-CLIENT': 'SI-REG',
            },
            method: 'put',
            url: appVars.getAPIGatewayURL() + "/password",
            // url: '/v2/admin/customer/password/siRegAzureId?idType=azureId',
            /*headers: {
                'X-API-KEY': await appVars.getAPIKey(),
                'X-BRAND': 'T',
                'X-CLIENT': 'SI-REG',
                'X-VERSION': '1.6',
                'Content-Type': 'application/json',
            }, */
            data: {
                'newPassword': password,
                'resetCode': this.props.code
            }
        })
        .then((resp) => this.handleResetSuccess(resp))
        .catch((err) => this.handleResetError(err))
    }

    handleResetSuccess(resp) {
        this.setState({
            loadingReset: false,
            passwordLoading: false,
        });
        this.props.displayForm("SUCCESS")
    }

    handleResetError(err) {
        this.setState({
            loadingReset: false,
            passwordLoading: false
        });
        this.props.displayForm("ERROR")
    }

    handlePasswordChange(event) {
        this.setState({password: event.target.value});
        this.checkPassword(event.target.value)
    }

    handleConfirmPasswordChange(event) {
        this.setState({confirmPassword: event.target.value});
        this.checkConfirmPassword(event.target.value)
    }

    checkPassword(value) {
        if (!value || !this.passwordRegex.test(value)) {
            this.setState({
                isPasswordValid: false
            });  
        } else {
            this.setState({
                isPasswordValid: true
            });  
        }
    }

    checkConfirmPassword(value) {
        if (!value || !(value === this.state.password)) {
            this.setState({
                isConfirmPasswordValid: false
            });  
        } else {
            this.setState({
                isConfirmPasswordValid: true
            });  
        }
    }

    onFocusPassword() {
        this.setState({
            floatPassword: false,
            passwordFocus: true
        })
    }

    removeFocusPassword(){
        this.setState({passwordFocus: false})
    }

    onBlurPassword() {
        if (this.state.password === "") {
            this.setState({
                floatPassword: true
            })
        }
        else {
            this.setState({
                floatPassword: false
            })
        }
        this.removeFocusPassword()
        this.checkPassword(this.state.password)
    }

    onFocusConfirmPassword() {
        this.setState({
            floatConfirmPassword: false,
            confirmPasswordFocus: true
        });
    }

    removeFocusConfirmPassword(){
        this.setState({confirmPasswordFocus: false})
    }

    onBlurConfirmPassword() {
        if (this.state.confirmPassword === "") {
            this.setState({
                floatConfirmPassword: true
            });
        }
        else {
            this.setState({
                floatConfirmPassword: false
            });
        }
        this.removeFocusConfirmPassword()
        this.checkConfirmPassword(this.state.confirmPassword)
    }
    
}

export default UpdatePasswordForm